import { makeStyles } from "@material-ui/core/styles";

const styles = makeStyles(theme => ({
  paper: {
    padding: theme.spacing(2),
    textAlign: "left",
    color: theme.palette.text.secondary,
    minHeight: "230px",
    background: "#fafafa",
    cursor: "pointer",
    position: "relative",
    "&:hover": {
      boxShadow:
        "0px 3px 3px -2px rgb(0 0 0 / 20%), 0px 3px 4px 0px rgb(0 0 0 / 14%), 0px 1px 8px 0px rgb(0 0 0 / 12%)"
    },
    [theme.breakpoints.down("xs")]: {
      width: "260px",
      marginRight: "15px",
      boxShadow:
        "0px 3px 3px -2px rgb(0 0 0 / 20%), 0px 3px 4px 0px rgb(0 0 0 / 14%), 0px 1px 8px 0px rgb(0 0 0 / 12%)"
    }
  },
  cardTtitle: {
    fontSize: "24px",
    fontWeight: 500,
    fontStyle: "normal",
    lineHeight: "1.17",
    color: "rgba(0, 0, 0, 0.87)",
    marginTop: "0px"
  },
  cardDescription: {
    fontSize: "16px",
    fontWeight: "normal",
    fontStyle: "normal",
    lineHeight: "1.25",
    color: "#727272"
  },
  playIndicator: {
    textAlign: "right",
    display: "flex",
    justifyContent: "flex-end",
    cursor: "pointer",
    alignItems: "center",
    position: "absolute",
    right: "10px",
    bottom: "10px"
  },
  marginRight1: {
    marginRight: 5
  }
}));

export default styles;
